/**
 * Sinais do chat no desenho do WhatsApp (pedido do Igor, 2026-10-28), usados
 * no balão e na lista de conversas:
 *  - ✓ enviada, ✓✓ entregue, ✓✓ azul lida (SVG, não caractere);
 *  - o microfone do áudio, azul quando ouvido;
 *  - os três pontinhos pulando de quem está digitando.
 */

const ROTULO_DA_MARCA = {
  enviando: "enviando",
  enviada: "enviada",
  entregue: "entregue a todos",
  lida: "lida por todos",
  falhou: "não enviada",
};

export function MarcaDeEnvio({ marca, titulo }) {
  if (!marca || marca === "falhou") return null;
  const rotulo = ROTULO_DA_MARCA[marca] || marca;
  if (marca === "enviando") {
    return (
      <span className="pchat-marca enviando" title={titulo || rotulo} aria-label={rotulo}>
        <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
          <circle cx="8" cy="8" r="6" />
          <path d="M8 4.8V8l2 1.4" />
        </svg>
      </span>
    );
  }
  const dupla = marca === "entregue" || marca === "lida";
  return (
    <span className={`pchat-marca ${marca}`} title={titulo || rotulo} aria-label={rotulo}>
      <svg viewBox="0 0 18 12" width="17" height="12" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {dupla ? (
          <>
            <path d="M1.5 6.6 4.6 9.6 11 2.6" />
            <path d="M8.2 9.6 14.6 2.6" />
            <path d="M6.8 8.2 8.2 9.6" />
          </>
        ) : (
          <path d="M4 6.6 7.1 9.6 13.5 2.6" />
        )}
      </svg>
    </span>
  );
}

export function MicDoAudio({ ouvido, tamanho = 14 }) {
  return (
    <span className={`pchat-mic ${ouvido ? "ouvido" : ""}`} title={ouvido ? "ouvido" : "ainda não ouvido"} aria-label={ouvido ? "áudio ouvido" : "áudio ainda não ouvido"}>
      <svg viewBox="0 0 24 24" width={tamanho} height={tamanho} fill="currentColor" aria-hidden="true">
        <path d="M12 14.5a3.5 3.5 0 0 0 3.5-3.5V5.5a3.5 3.5 0 0 0-7 0V11a3.5 3.5 0 0 0 3.5 3.5z" />
        <path d="M18.2 11a.9.9 0 0 0-1.8 0 4.4 4.4 0 0 1-8.8 0 .9.9 0 0 0-1.8 0 6.2 6.2 0 0 0 5.3 6.1V20H9a.9.9 0 0 0 0 1.8h6a.9.9 0 0 0 0-1.8h-2.1v-2.9a6.2 6.2 0 0 0 5.3-6.1z" />
      </svg>
    </span>
  );
}

export function Digitando({ texto = "digitando" }) {
  return (
    <span className="pchat-digitando-linha" aria-live="polite">
      <span className="pontos" aria-hidden="true"><i /><i /><i /></span>
      <em>{texto}</em>
    </span>
  );
}
